import { useQuery } from '@tanstack/react-query';

/**
 * Custom hook to fetch Agility content list
 * Calls server-side API to access Agility credentials safely
 * @param contentListName - Reference name of the Agility content list/model
 * @param locale - Locale code (default: 'en-us')
 * @returns Query object with data, isLoading, error, and refetch
 */
export const useAgilityContent = (
  contentListName?: string,
  locale = 'en-us',
) => {
  return useQuery({
    queryKey: ['agility-content', contentListName, locale],
    queryFn: async () => {
      if (!contentListName) {
        throw new Error('contentListName is required');
      }
      const params = new URLSearchParams({
        listName: contentListName,
        locale,
      });
      const response = await fetch(`/api/agility/content?${params}`);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.details ||
            errorData.error ||
            'Failed to fetch Agility content',
        );
      }
      const { items } = await response.json();
      return items;
    },
    enabled: !!contentListName,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
